import { render } from "./PostActions.vue?vue&type=template&id=bd0c7ef6&ts=true"
import script from "./PostActions.vue?vue&type=script&lang=ts"
export * from "./PostActions.vue?vue&type=script&lang=ts"

import "./PostActions.vue?vue&type=style&index=0&id=bd0c7ef6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__